var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6883 7.01799C11.8827 6.82186 11.8813 6.50528 11.6851 6.31089C11.489 6.1165 11.1724 6.11791 10.978 6.31404L9.81317 7.48936C9.34041 7.96635 9.01505 8.29355 8.73937 8.51495C8.47157 8.73002 8.29956 8.8038 8.14551 8.82344C8.04878 8.83577 7.9509 8.83577 7.85417 8.82344C7.70012 8.8038 7.5281 8.73002 7.26031 8.51495C6.98462 8.29355 6.65926 7.96635 6.1865 7.48936L5.02163 6.31404C4.82724 6.11791 4.51066 6.1165 4.31453 6.31089C4.1184 6.50528 4.11699 6.82186 4.31138 7.01799L5.49723 8.21447C5.94386 8.66512 6.3089 9.03344 6.63414 9.29465C6.97236 9.56626 7.31565 9.76289 7.72773 9.81541C7.90841 9.83844 8.09126 9.83844 8.27195 9.81541C8.68402 9.76289 9.02731 9.56626 9.36553 9.29465C9.69078 9.03344 10.0558 8.66513 10.5024 8.21448L11.6883 7.01799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.7732b24b46b644a7be6bf6ed8da27548.svg";
export { ForwardRef as ReactComponent };